import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllGroupSetsSpace, AllGroupSetsSpaceDispatchProps, AllGroupSetsSpaceOwnProps, AllGroupSetsSpaceStateProps } from './AllGroupSetsSpace';

const mapStateToProps: MapStateToProps<AllGroupSetsSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedGroupSets: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
});

const mapDispatchToProps: MapDispatchToProps<AllGroupSetsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
}, dispatch);

export const ConnectedAllGroupSetsSpace: React.ComponentClass<AllGroupSetsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllGroupSetsSpace);
